import { render } from "./MyAccount.vue?vue&type=template&id=9dd4bcf4&scoped=true&bindings={\"tabs\":\"data\",\"activeTab\":\"data\"}"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=9dd4bcf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9dd4bcf4"

export default script